"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var redux_1 = require("redux");
var reducer_1 = __importDefault(require("./reducer"));
var api_1 = __importDefault(require("../../../middlewares/api"));
var redux_thunk_1 = __importDefault(require("redux-thunk"));
var connected_react_router_1 = require("connected-react-router");
var history_1 = __importDefault(require("../../common/Router/history"));
var IS_BROWSER = typeof window === 'object';
var composeEnhancers = IS_BROWSER && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__
    ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__({
    // Specify extension’s options like name, actionsBlacklist, actionsCreators, serialize...
    })
    : redux_1.compose;
var middlewares = [
    redux_thunk_1.default,
    api_1.default,
    IS_BROWSER
        ? (0, connected_react_router_1.routerMiddleware)(history_1.default)
        : function () { return function (next) { return function (action) {
            next(action);
        }; }; },
];
var enhancer = composeEnhancers(redux_1.applyMiddleware.apply(void 0, middlewares));
var createStoreForSSR = function (initialStore) {
    return (0, redux_1.createStore)(reducer_1.default, initialStore, enhancer);
};
exports.default = createStoreForSSR;
